<template>
  <div class="w-full bg-gray-100 border border-gray-200 rounded-lg p-6 md:p-8 lg:p-12 text-center text-gray-700">
    <slot></slot>
  </div>
</template>
